import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { UserInterestPayload } from "../../../api/UserInterestApi";
import { ChevronDownIcon } from "@chakra-ui/icons";

const rvuOptions = [
  { label: "0-200", value: "0-200" },
  { label: "201-500", value: "201-500" },
  { label: "501-1000", value: "501-1000" },
  { label: "1000+", value: "1000+" },
];

const RvuPerMonth: React.FC<{
  onRvuPerMonth: (val: string) => void;
  formData: UserInterestPayload;
}> = ({ formData, onRvuPerMonth }) => (
  <FormControl maxW="368" alignSelf="center">
    <FormLabel color="gray.500" fontSize="12px" fontWeight="700">
      How many RVUs per Month are you interested in doing?
    </FormLabel>
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant="outline"
        w="full"
        textAlign="left"
        height={14}
        borderColor="gray.300"
        fontWeight="400"
        color={`gray.${formData.rvuPerMonth ? 800 : 400}`}
      >
        {formData.rvuPerMonth || "Select"}
      </MenuButton>
      <MenuList>
        {rvuOptions.map((option) => (
          <MenuItem key={option.value} onClick={() => onRvuPerMonth(option.value)}>
            <HStack justify="space-between">
              <Checkbox
                isChecked={formData.rvuPerMonth === option.value}
                colorScheme="brandBlue"
              />
              <Text color="gray.600" textStyle="smMdSemi" flex="1">
                {option.label}
              </Text>
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  </FormControl>
);

export default RvuPerMonth;
